import React, {Component} from 'react';
import '../static/scss/header.scss';
import Navbar from "./navbar";
import Social from "./social";

class Header extends Component {
    render() {
        return (
            <header>
                <div className="wrapper">
                    <Navbar/>
                    <Social/>
                </div>
            </header>
        );
    }
}

export default Header;